import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo, setJsonLd } from "@/hooks/useSeo";

const FORM_URL = "https://readdy.ai/api/form/da1aat1st185ek8asnq0";

const pillars = [
  { icon: "ri-heart-3-line", t: "免费开放", d: "坚持核心资源免费在线观看，降低追番门槛，让更多漫迷无负担享受动画。" },
  { icon: "ri-stack-line", t: "全集收录", d: "完结番剧一次性收录全集，新番同步更新，找番、看番、存番一站式完成。" },
  { icon: "ri-hd-line", t: "高清体验", d: "持续整理 1080P / 4K 高清资源，画面清晰，观影体验不打折扣。" },
  { icon: "ri-refresh-line", t: "持续更新", d: "资源库保持高频整理更新，紧跟最新热番，追更不掉队。" },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  useSeo({
    title: "关于我们 - 奶水动漫，热门动画免费观看与高清下载资源站",
    description:
      "了解奶水动漫：我们专注为漫迷提供热门动画免费在线观看、全集收录与高清下载服务。查看网站定位、内容原则与用户口碑，欢迎随时联系我们。",
    keywords: "奶水动漫,关于我们,动漫资源,在线观看,高清下载",
  });

  setJsonLd("ld-about", {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于奶水动漫",
    description: "奶水动漫是一个为二次元漫迷提供热门动画免费在线观看与高清下载的动画资源站。",
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // honeypot check
    const honeypot = String(fd.get("contact_alt") || "").trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }

    // exclude honeypot from payload
    const body = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === "contact_alt") return;
      body.append(key, String(value));
    });

    setFormStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await res.text();
      let ok = res.ok;
      let msg = "";
      try {
        const parsed = JSON.parse(responseText);
        const m = (parsed?.meta?.message as string) || (parsed?.message as string) || (parsed?.meta?.detail as string) || "";
        msg = m;
        if (!(parsed?.code === "OK")) ok = false;
        if (/spam/i.test(m) || /form data is spam/i.test(responseText)) ok = false;
      } catch {
        ok = false;
      }
      if (ok) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        setFormError(msg || "提交失败，请稍后再试");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络异常，请稍后再试");
    }
  };

  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main className="pt-16">
        <section className="border-b border-background-800 bg-background-900/40">
          <div className="container-site py-10 md:py-14">
            <nav className="mb-4 flex items-center gap-1 text-xs text-foreground-500" aria-label="面包屑">
              <Link to="/" className="transition-colors hover:text-primary-400">首页</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-300">关于我们</span>
            </nav>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1 text-xs font-medium text-primary-400">
              <i className="ri-information-line" /> 关于奶水动漫
            </span>
            <h1 className="mt-4 font-heading text-3xl text-foreground-50 md:text-4xl">让每一位漫迷都能轻松追番</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
              奶水动漫是一个专注二次元漫迷的动画资源站。我们希望通过免费在线观看、全集收录与高清下载，解决漫迷找番难、看番繁琐、存番不便的问题，让看番回归纯粹的快乐。
            </p>
          </div>
        </section>

        <section className="container-site py-10 md:py-14">
          <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
            <div>
              <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50">
                <i className="ri-quill-pen-line text-primary-500" /> 我们的理念
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">
                我们相信，好的动画值得被更多人看到。无论是热血沸腾的战斗、细腻动人的恋爱，还是脑洞大开的奇幻冒险，都应该有一个简单直接的入口。奶水动漫的初衷，就是把资源整理清楚、更新到位，让用户「点开即追更」，把时间留给内容本身。
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">
                目前站内已收录上千部热门动画，覆盖热血、奇幻、科幻、恋爱、悬疑、古风、日常、运动等多类型，持续扩充并同步更新最新集数，满足不同类型漫迷的多元需求。
              </p>

              <div className="mt-6 grid gap-3 sm:grid-cols-2">
                {pillars.map((p) => (
                  <div key={p.t} className="rounded-lg border border-background-800 bg-background-900 p-4">
                    <i className={`${p.icon} text-xl text-primary-400`} />
                    <h3 className="mt-2 text-sm font-bold text-foreground-100">{p.t}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-400">{p.d}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-6">
              <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50">
                <i className="ri-scales-3-line text-primary-500" /> 内容原则
              </h2>
              <div className="space-y-3">
                {[
                  { n: "01", t: "尊重创作者", d: "本站资源整理旨在方便漫迷交流学习，请合理使用，支持正版请前往官方渠道。" },
                  { n: "02", t: "清晰准确", d: "分类、集数与清晰度信息持续校对整理，确保找番体验准确流畅。" },
                  { n: "03", t: "体验优先", d: "页面干净、操作简单，不做繁琐引导，把追番的每一步都变简单。" },
                  { n: "04", t: "长期更新", d: "资源库保持高频更新，紧跟热番节奏，陪伴漫迷的长线需求。" },
                ].map((c) => (
                  <div key={c.n} className="flex gap-4 rounded-lg border border-background-800 bg-background-900 p-4">
                    <span className="font-heading text-2xl text-primary-500">{c.n}</span>
                    <div>
                      <h3 className="text-sm font-bold text-foreground-100">{c.t}</h3>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-400">{c.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="border-t border-background-800 bg-background-900/40 py-10 md:py-14">
          <div className="container-site grid gap-10 lg:grid-cols-2">
            <div>
              <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50">
                <i className="ri-customer-service-2-line text-primary-500" /> 联系我们
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-400">
                无论是找番建议、资源反馈还是合作交流，都欢迎通过下方表单与我们联系。我们会在收到后尽快回复。
              </p>
              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-3 rounded-lg border border-background-800 bg-background-900 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-primary-400"><i className="ri-mail-line" /></span>
                  <div>
                    <p className="text-xs text-foreground-500">电子邮箱</p>
                    <p className="text-sm text-foreground-100">contact@nsshipin.site</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 rounded-lg border border-background-800 bg-background-900 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-primary-400"><i className="ri-time-line" /></span>
                  <div>
                    <p className="text-xs text-foreground-500">工作时间</p>
                    <p className="text-sm text-foreground-100">周一至周日 09:00 - 22:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-xl border border-background-800 bg-background-900/70 p-6 md:p-8">
              <h3 className="text-lg font-bold text-foreground-100">发送消息给我们</h3>
              <form onSubmit={onSubmit} data-readdy-form className="mt-5 space-y-4">
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label htmlFor="name" className="mb-1.5 block text-sm text-foreground-300">你的称呼</label>
                    <input id="name" name="name" type="text" required placeholder="怎么称呼你" className="w-full rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 outline-none transition-colors placeholder:text-foreground-600 focus:border-primary-500" />
                  </div>
                  <div>
                    <label htmlFor="email" className="mb-1.5 block text-sm text-foreground-300">联系邮箱</label>
                    <input id="email" name="email" type="email" required placeholder="name@example.com" className="w-full rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 outline-none transition-colors placeholder:text-foreground-600 focus:border-primary-500" />
                  </div>
                </div>
                <div>
                  <label htmlFor="subject" className="mb-1.5 block text-sm text-foreground-300">留言主题</label>
                  <input id="subject" name="subject" type="text" placeholder="例如：资源反馈、合作交流" className="w-full rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 outline-none transition-colors placeholder:text-foreground-600 focus:border-primary-500" />
                </div>
                <div>
                  <label htmlFor="message" className="mb-1.5 block text-sm text-foreground-300">留言内容</label>
                  <textarea id="message" name="message" required rows={5} maxLength={500} placeholder="请描述你的需求或建议，不超过 500 字" className="w-full resize-none rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 outline-none transition-colors placeholder:text-foreground-600 focus:border-primary-500" />
                </div>

                <input type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="field-guard" />

                <button type="submit" disabled={formStatus === "loading"} className="btn-primary w-full disabled:opacity-60">
                  {formStatus === "loading" ? "发送中…" : "提交留言"}
                </button>

                {formStatus === "success" && (
                  <p className="flex items-center gap-2 rounded-md bg-primary-500/15 px-4 py-2.5 text-sm font-medium text-primary-400">
                    <i className="ri-checkbox-circle-fill" /> 感谢你的留言，我们会尽快回复你！
                  </p>
                )}
                {formStatus === "error" && (
                  <p className="flex items-center gap-2 rounded-md bg-accent-500/15 px-4 py-2.5 text-sm font-medium text-accent-400">
                    <i className="ri-error-warning-fill" /> {formError || "提交失败，请稍后再试"}
                  </p>
                )}
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}